import React, { useState, useRef } from 'react'
import { message, Tooltip } from 'antd'

function NextBoxDiaryDetailsRow(props) {
    const { item } = { ...props }
    const { carrier_name, boxes = [] } = { ...item }
    // const [selectedDate, setSelectedDate] = useState(currentDate ? moment(currentDate).format('DD/MM/YYYY') : '')
    const [showAll, setShowAll] = useState(false)

    const showallonclick = () => {
        setShowAll(!showAll)
    }

    // useEffect(() => {
    //     if (currentDate) {
    //         setSelectedDate(currentDate ? moment(currentDate).format('DD/MM/YYYY') : '')
    //     }
    // }, [currentDate])

    const totalOrders = carrier_name === 'VN' && boxes.length > 0 ? boxes.reduce((acc, box) => {
        return acc + (box.orders ? box.orders.length : 0)
    }, 0) : '-'

    const allOrders = carrier_name === 'VN' && boxes.length > 0 ? boxes.reduce((acc, box) => {
        return acc.concat(box.orders || [])
    }, []) : []

    const allBoxNumber = boxes.length > 0 ? boxes.map(i => `#${i.number}`) : []

    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(`${text}`)
            message.success('Copied!')
        } catch (error) {
            message.error('Copy error!', error)
        }
    }
    const myRef = useRef()

    return (
        <tr>
            {/* <td><Checkbox checked={_detectChecked()} onChange={_handleChange} /></td> */}
            <td>{carrier_name || '-'}</td>
            <td>
                {carrier_name === 'VN' ? totalOrders :
                    (boxes ? boxes.length : '-')
                }
            </td>
            <td className='BoxNumberAndBarCode'>
                <div className={showAll === false ? "HiddenData" : ""}>
                    <div ref={myRef}>
                        <Tooltip title='Copy'>
                            <span className='cursor-pointer' onClick={() => handleCopy(carrier_name === 'VN' ? allOrders.join(', ') : allBoxNumber.join(', '))}>
                                {carrier_name === 'VN' ?
                                    allOrders.join(', ') :
                                    allBoxNumber.join(', ')
                                }
                            </span>
                        </Tooltip>
                    </div>
                </div>
                {
                    !!myRef.current ? (
                        (myRef.current.offsetHeight > 56 && showAll === false) ?
                            <a className="float-right mt-2 text-primary">
                                <small className="float-right" onClick={showallonclick}>More...</small>
                            </a> :
                            (myRef.current.offsetHeight > 56 && showAll === true) ?
                                <a className="float-right mt-2 text-primary">
                                    <small className="float-right" onClick={showallonclick}>Less...</small>
                                </a> : ""
                    ) : ""
                }
            </td>
            {/* <td>
                <div className='d-flex'>
                    <Popconfirm
                        title={`Bạn có chắc chắn muốn xóa thùng #${number} ?`}
                        okText="Yes"
                        cancelText="No"
                        onConfirm={onDelete}
                    >
                        <i className="fa fa-trash fa-lg mx-1 text-danger" aria-hidden="true"></i>
                    </Popconfirm>
                    <i className="fa fa-pencil-square-o fa-lg mx-1" aria-hidden="true" onClick={toggleDatePicker}></i>
                    <div className='DiaryNextBoxesSelectDate'>
                        {
                            isOpenDatePicker &&
                            <div className='DiaryNextBoxesSelectDateOverlay' onClick={() => handleClickOutsideDatePicker()}></div>
                        }
                        <DatePicker
                            className="mcHiddenInput"
                            value={selectedDate ? moment(selectedDate, 'DD/MM/YYYY') : ''}
                            open={isOpenDatePicker}
                            format={'DD/MM/YYYY'}
                            disabledDate={disabledDate}
                            onChange={onSelectDate}
                            inputReadOnly
                            dateRender={dateRender}
                        />
                    </div>
                </div>
            </td> */}
        </tr>
    )
}

export default NextBoxDiaryDetailsRow
